/* globals Buffer process */
/* eslint-env browser */

export default !process.env.BROWSER
  ? str => new Buffer(str, 'base64').toString('binary')
  : window.atob;
